import { storeGet, storeSet } from "@/utils/localStore"

const defaultUserInfo = {
  open_id: ''
}

const state = {
  open_id: storeGet('OPEN_ID'),
  uid: storeGet('U_ID'),
  gameUserName: storeGet('GAME_USER_NAME'),
  access_token: '',
}

const mutations = {
  UPDATE_USER_INFO (state, payload = {}) {
    state.open_id = payload.open_id
    storeSet('OPEN_ID', payload.open_id)
    state.access_token = payload.access_token
  },
  UPDATE_U_ID (state, id = '') {
    state.uid = id
    storeSet('U_ID', id)
  },
  UPDATE_GAME_USER_NAME (state, name = '') {
    state.gameUserName = name
    storeSet('GAME_USER_NAME', name)
  },
}

const actions = {}

const getters = {
  openid: state => state.open_id || storeGet('OPEN_ID'),
  uid: state => state.uid || storeGet('U_ID'),
  gameUserName: state => state.gameUserName || storeGet('GAME_USER_NAME'),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};